const Led = require("./led");
Led.Collection = require("./leds");
Led.RGB = require("./rgb");
Led.RGB.Collection = require("./rgbs");
Led.Matrix = require("./matrix");
Led.Digits = require("./digits");

module.exports = Led;
